import { apiDelete, apiGet, apiPost } from "../../../utils";

export function createVesselCargoAnalysisAPI(data) {
  return apiPost("/api/vesselCargoAnalysis/create", data);
}

export function getVesselCargoAnalysisListAPI(query) {
  return apiGet("/api/vesselCargoAnalysis/list", query);
}

export function getVesselCargoAnalysisByIdAPI(id) {
  return apiGet(`/api/vesselCargoAnalysis/detail/${id}`);
}

export function deleteVesselCargoAnalysisAPI(id) {
  return apiDelete(`/api/vesselCargoAnalysis/delete/${id}`);
}
